import {
  DISTRIBUTOR_CONTACT_DETAILS,
  REGISTER_DISTRIBUTOR_DETAILS,
  UPLOAD_DRUG_LICENCE,
  UPLOAD_GST_CERTIFICATE,
} from "./types";

export const uploadDrugLicence = (image, onSuccess, onError) => {
  return {
    type: UPLOAD_DRUG_LICENCE,
    image,
    onSuccess,
    onError,
  };
};

export const uploadGSTCertificate = (image, onSuccess, onError) => {
  return {
    type: UPLOAD_GST_CERTIFICATE,
    image,
    onSuccess,
    onError,
  };
};

export const registrationDetail = (data, onSuccess, onError) => {
  return {
    type: REGISTER_DISTRIBUTOR_DETAILS,
    data,
    onSuccess,
    onError,
  };
};

export const contactDetail = (data, onSuccess, onError) => {
  return {
    type: DISTRIBUTOR_CONTACT_DETAILS,
    data,
    onSuccess,
    onError,
  };
};
